<template>
    <DsModal
        class="dd-import-rules-modal"
        :is-open="isOpen"
        :title="$t('funnel.edit.lightbox.rulegroup.title')"
        size="sm"
    >
        <template #default>
            <section class="sequence-selection-option-wrapper">
                <DsMultiselect
                    v-model="selectedSequence"
                    data-qa="sequence-multiselect"
                    :options="sequenceOptions"
                    :placeholder="$t('funnel.edit.lightbox.rulegroup.select.default')"
                >
                    <template #help>
                        {{ $t('funnel.edit.lightbox.rulegroup.select.label') }}
                    </template>
                </DsMultiselect>

                <div class="importing-rules-from-into">
                    <span>
                        <span>{{ $t('funnel.edit.lightbox.rulegroup.from') }} </span>
                        <span :class="sequenceLabelClass">{{ sequenceLabel }}</span>
                    </span>
                    <span>
                        <span>{{ $t('funnel.edit.lightbox.rulegroup.into') }} </span>
                        <span class="original-title">{{ titleSequenceOriginal }}</span>
                    </span>
                </div>

                <div class="button-group-action">
                    <DsButton
                        class="import-rules-button"
                        @click="seqImportRules"
                    >
                        {{ $t('funnel.edit.lightbox.rulegroup.button.import') }}
                    </DsButton>
                    <DsTextButton
                        blue
                        class="cancel-import-rules-button"
                        @click="cancelImportRules"
                    >
                        {{ $t('funnel.edit.lightbox.rulegroup.button.cancel') }}
                    </DsTextButton>
                </div>
            </section>
        </template>
    </DsModal>
</template>

<script>
import {
    importRules,
    sequenceImportRules,
} from './decision.api';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        titleSequenceOriginal: {
            type: String,
            required: true,
            default: '',
        },
        targetRuleGroupId: {
            type: Number,
            required: true,
        },
        ddKeys: {
            type: Object,
            required: true,
        },
        flowIds: {
            type: Array,
            required: true,
        },
        flowNames: {
            type: Array,
            required: true,
        },
        decisionIds: {
            type: Array,
            required: true,
        },
    },
    emits: ['import-rules', 'cancel-import-rules'],
    data() {
        return {
            selectedSequence: null,
            sequenceOptions: [],
        };
    },
    computed: {
        sequenceLabelClass() {
            return this.selectedSequence ? 'new-title' : 'gray-title';
        },
        sequenceLabel() {
            return this.selectedSequence && this.selectedSequence.label
                ? this.selectedSequence.label
                : this.$t('funnel.edit.lightbox.rulegroup.make.selection');
        },
    },
    mounted() {
        this.getSequenceOptions();
    },
    methods: {
        async getSequenceOptions() {
            const params = new URLSearchParams({
                targetRuleGroupId: this.targetRuleGroupId,
                flowIds: this.flowIds.join(','),
                flowNames: this.flowNames.join(','),
                decisionIds: this.decisionIds.join(','),
                ...this.ddKeys,
            }).toString();

            const { ruleGroupIdToFlowNameMap } = await importRules(params);

            this.sequenceOptions = Object.keys(ruleGroupIdToFlowNameMap).map((key) => ({
                value: key,
                label: ruleGroupIdToFlowNameMap[key],
            })).filter(({ label }) => label !== '');
        },
        async seqImportRules() {
            if (this.selectedSequence == null) {
                return;
            }
            const sourceRuleGroupId = this.selectedSequence.value;
            const { targetRuleGroupId } = this;
            const { ruleGroup } = await sequenceImportRules(sourceRuleGroupId, targetRuleGroupId, this.ddKeys);

            this.$emit('import-rules', ruleGroup);
            this.cancelImportRules();
        },
        cancelImportRules() {
            this.$emit('cancel-import-rules');
        },
    },
};
</script>

<style lang="scss" scoped>
.sequence-selection-option-wrapper {
    display: flex;
    flex-direction: column;
}

.button-group-action {
    display: flex;
    flex-direction: row;
    margin-top: $spacing-200;
}

.importing-rules-from-into {
    display: flex;
    flex-direction: column;
}

.original-title {
    font-weight: bold;
}

.gray-title {
    color: $color-gray-300;
}

.new-title {
    font-weight: bold;
}

.import-rules-button {
    margin-right: $spacing-125;
}

</style>
